/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_No_PaymentsInputs */

const en_admin_payments_no_payments = /** @type {(inputs: Admin_Payments_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments yet`)
};

const zh_admin_payments_no_payments = /** @type {(inputs: Admin_Payments_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无支付记录`)
};

/**
* | output |
* | --- |
* | "No payments yet" |
*
* @param {Admin_Payments_No_PaymentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_no_payments = /** @type {((inputs?: Admin_Payments_No_PaymentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_No_PaymentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_no_payments(inputs)
	return zh_admin_payments_no_payments(inputs)
});
export { admin_payments_no_payments as "admin.payments.no_payments" }